<template>
  <div>
    {{ info.title }}
    <div
      class="tool-tip"
      v-if="info.copy && info.copy.length !== 0"
      :class="{ '--is-active': shownTooltip }"
    >
      <span
        class="tool-tip__icon +text-center"
        v-bind:id="tooltipIconId"
        v-on:click.stop="showTooltip"
        >i</span
      >
      <div
        class="tool-tip__box --right"
        v-show="shownTooltip"
        v-on:click="hideTooltip"
      >
        <div class="tool-tip__arrow"></div>
        <template v-for="(item, index) in info.copy">
          <h4 v-if="item.copyTitle" :key="index">{{ item.copyTitle }}</h4>
          <p :key="index + 'a'">{{ item.copy }}</p>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import eventHub from '../bankrate-events/index'
import utils from '../../bankrate-utilities/index'

// @DEPRECATED - Rewrite or clean up for any future use
export default {
  data: function() {
    return {
      shownTooltip: false,
      info: {
        title: this.$parent.title
          ? this.$parent.title
          : this.$parent.settings.title,
        copy: this.$parent.copy
      }
    }
  },

  created: function() {
    eventHub.$on('tooltip::close', this.hideTooltip)
  },

  computed: {
    tooltipIconId: function() {
      return utils.spacesFormat(this.info.title) + 'TT'
    }
  },

  methods: {
    showTooltip: function() {
      eventHub.$emit('adDisclosure::close')
      if (this.shownTooltip === true) {
        this.shownTooltip = false
      } else {
        eventHub.$emit('tooltip::close')
        this.shownTooltip = true
      }
    },
    hideTooltip: function() {
      this.shownTooltip = false
    }
  }
}
</script>
